<template>
  <div style="color: white">
    <b-toast
        id="inPracticeToast"
        variant="success"
        toaster="b-toaster-top-center"
        :body-class="'h4 text-center'"
        style="padding:0.25rem; max-width:500px;"
        no-auto-hide
        no-close-button
        solid
      >{{ msgInPractice }}</b-toast>
    <div v-if="currentWord">
      <b-row class="content-header">
        <b-col class="mr-auto" cols="3">词类：{{ currentWord.part_of_speech }}</b-col>
        <!-- <b-col cols="2">
          <voice-input-button
            :appId="appId"
            :apiKey="apiKey"
            :apiSecret="apiSecret"
            v-model="result"
            @record="showResult"
            @record-start="recordStart(idx)"
            @record-stop="recordStop"
            @record-blank="recordNoResult"
            @record-failed="recordFailed"
            @record-ready="recordReady"
            @record-complete="recordComplete"
            interactiveMode="touch"
            color="#fff"
            tipPosition="top"
            language="en_us"
          >
            <template slot="no-speak">没听清您说的什么</template>
          </voice-input-button>
        </b-col> -->
        <div v-if="currentWord.us_pron !== null && currentWord.us_pron.length > 0">
          <b-col class="small mr-4" cols="2">
            <b-button
              class="custom-button one"
              style="width: 100px !important;"
              @click="playAudio(currentWord.us_pron)"
            >
              <b-icon-volume-up-fill></b-icon-volume-up-fill>播放US
              <br />[Ctrl + 1]
            </b-button>
          </b-col>
        </div>
        <div v-if="currentWord.uk_pron !== null && currentWord.uk_pron.length > 0">
          <b-col class="small mr-4" cols="2">
            <b-button
              class="custom-button one"
              style="width: 100px !important;"
              @click="playAudio(currentWord.uk_pron)"
            >
              <b-icon-volume-up-fill></b-icon-volume-up-fill>播放UK
              <br />[Ctrl + 2]
            </b-button>
            <br />
            {{ currentWord.uk_phonetic }}
          </b-col>
        </div>
        <div v-if="currentWord.ch_pron !== null && currentWord.ch_pron.length > 0">
          <b-col class="small mr-4" cols="2">
            <b-button
              class="custom-button one"
              style="width: 100px !important;"
              @click="playAudio(currentWord.ch_pron)"
            >
              <b-icon-volume-up-fill></b-icon-volume-up-fill>播放中文
              <br />[Ctrl + 3]
            </b-button>
            <br />
          </b-col>
        </div>
      </b-row>
      <b-row class="en-word">
        <b-col cols="12">{{ currentWord.word }}</b-col>
      </b-row>
      <b-row class="subtitle">
        <b-col cols="12">{{ currentWord.us_phonetic }}</b-col>
      </b-row>
      <b-row class="subtitle">
        <b-col cols="12">{{ currentWord.meaning }}</b-col>
      </b-row>
      <b-row class="dash-line">
        <b-col cols="12">
          <hr class="dash" />
        </b-col>
      </b-row>

      <div>
        <div class="input-area">
          <div v-if="practiceMode === false">
            <span :style="correctStringStyle">{{ correctString }}</span>
            <span class="error-character">{{ errorCharacter }}</span>
            <span class="cursor" />
          </div>
          <div v-else>
            <span style="font-size: 16px;">请&nbsp;<b-icon icon="arrow-right"></b-icon>&nbsp;键前往下一个，按&nbsp;<b-icon icon="arrow-left"></b-icon>&nbsp;键返回上一个</span>
          </div>
          <!-- <div v-if="!speechInput">
            <span :style="correctStringStyle">{{ correctString }}</span>
            <span class="error-character">{{ errorCharacter }}</span>
            <span class="cursor" />
          </div>
          <div v-else :style="correctStringStyle">
            <span
              v-for="(chObj, idx) in speechInputString"
              :key="idx"
              :class="chObj.style"
            >{{ chObj.character }}</span>
            <span class="cursor" />
          </div> -->
        </div>
      </div>

      <div class="sentence-block">
        <div v-if="currentWord.sentence">
          <b-row class="en-sentence ml-4 mr-4">
            <b-col class="sentence" cols="8">{{ currentWord.sentence.sentence }}</b-col>
            <b-col class="small" cols="2" v-show="currentWord.sentence.us_pron">
              <b-button class="custom-button one" @click="playAudio(currentWord.sentence.us_pron)">
                <b-icon-volume-up-fill></b-icon-volume-up-fill>播放
                <br />[Ctrl + 4]
              </b-button>
            </b-col>
            <b-col class="small" cols="2" v-show="currentWord.sentence.uk_pron">
              <b-button class="custom-button one" @click="playAudio(currentWord.sentence.uk_pron)">
                <b-icon-volume-up-fill></b-icon-volume-up-fill>播放
                <br />[Ctrl + 5]
              </b-button>
            </b-col>
          </b-row>
          <b-row class="en-sentence sentence-margin ml-4 mr-4">
            <b-col class="sentence" cols="8">{{ currentWord.sentence.meaning }}</b-col>
            <b-col class="small" cols="2" v-show="currentWord.sentence.ch_pron">
              <b-button class="custom-button one" @click="playAudio(currentWord.sentence.ch_pron)">
                <b-icon-volume-up-fill></b-icon-volume-up-fill>播放
                <br />[Ctrl + 6]
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <AchievementModal
      :modalName="'practiceWordResultModal'"
      :modalHeight="'auto'"
      :headerText="currentRecordHeaderText"
      :score="currentRecordDisplayScore"
      :lessonName="navigator"
      :extraText="leave ? '' : $t('Vocabulary.goToTest', [knownListLength + unknownListLength])"
      ref="practiceWordResultModal"
    >
      <template v-slot:buttons>
        <b-row>
          <b-col md="1" sm="0"></b-col>
          <b-col md="10" sm="12">
            <b-button
              v-if="!leave"
              class="custom-button four"
              style="width:200px !important;"
              @click="closeAndContinueHandler"
            >{{ $t('Common.nextStep') }} (Space)</b-button>
            <b-button
              v-else
              class="custom-button four"
              style="width:200px !important;"
              @click="leaveHandler"
            >{{ $t('Common.backToMenu') }} (b)</b-button>
          </b-col>
          <b-col md="1" sm="0"></b-col>
        </b-row>
      </template>
    </AchievementModal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import hotkeys from 'hotkeys-js'
// import voiceInputButton from 'voice-input-button2'

import SafeAudio from '../../../util/SafeAudio'
import SafeTimeout from '../../../util/SafeTimeout'
import Timer from '../../../util/Timer'
import { shuffle } from '@/util/array'
import { secondToHMS } from '../../../util/time'
import { roundDecimal } from '../../../util/math'
import AchievementModal from '../../CustomModal/AchievementModal.vue'
import { PRACTICEMODE } from '../vocabularyMode'

export default {
  name: 'PracticeViewContent',
  props: {
    showTestView: {
      type: Function,
      required: true
    },
    timer: {
      type: Timer,
      required: true
    },
    navigator: {
      type: Array,
      required: true
    },
    currentRecordProperties: {
      type: Array,
      required: true
    }
  },
  components: {
    // voiceInputButton,
    AchievementModal
  },
  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    console.log('this.currentWord:', this.currentWord)
    hotkeys('backspace', (e) => {
      e.preventDefault()
    })
    hotkeys('space', (e) => {
      e.preventDefault()
    })
    hotkeys('ctrl+1', (e) => {
      e.preventDefault()
      this.playAudio(this.currentWord.us_pron)
    })
    hotkeys('ctrl+2', (e) => {
      e.preventDefault()
      this.playAudio(this.currentWord.uk_pron)
    })
    hotkeys('ctrl+3', (e) => {
      e.preventDefault()
      this.playAudio(this.currentWord.ch_pron)
    })
    hotkeys('ctrl+4', (e) => {
      e.preventDefault()
      this.playAudio(this.currentWord.sentence.us_pron)
    })
    hotkeys('ctrl+5', (e) => {
      e.preventDefault()
      this.playAudio(this.currentWord.sentence.uk_pron)
    })
    hotkeys('ctrl+6', (e) => {
      e.preventDefault()
      this.playAudio(this.currentWord.sentence.ch_pron)
    })

    this.encourageTexts = shuffle(this.$t('Typing.encourageTexts'))
    this.playWordDefault()
    if (!this.started && this.practiceMode === PRACTICEMODE.SKIPTYPING) {
      this.isStarted = true
      this.timer.startTimer()
    }
  },
  beforeDestroy () {
    hotkeys.unbind()
    hotkeys.noConflict()
    window.removeEventListener('keydown', this.onKeydown)
  },
  destroyed () {
    this.correctString = ''
    this.errorCharacter = ''
    this.correctStringStyle = {}
    this.hasError = false
    this.timeoutManager.clearTimeouts()
  },
  watch: {
    isRestTime (newValue) {
      if (newValue === true) {
        this.timer.stopTimer()
      } else if (this.isStarted) {
        this.timer.startTimer()
      }
    }
  },
  data () {
    return {
      // appId: process.env.VUE_APP_XUNFEI_APP_ID,
      // apiKey: process.env.VUE_APP_XUNFEI_API_KEY,
      // apiSecret: process.env.VUE_APP_XUNFEI_API_SECRET,
      // speechInput: false,
      // speechInputString: [
      //   {
      //     style: null,
      //     character: ''
      //   }
      // ],
      correctString: '',
      errorCharacter: '',
      correctStringStyle: {},
      isStarted: false,
      hasError: false,
      countPerWord: 0,
      timeoutManager: new SafeTimeout(),
      currentRecordHeaderText: '',
      currentRecordDisplayScore: '',
      encourageTexts: [],
      msgInPractice: '',
      encourageTextIndex: 0
    }
  },
  computed: {
    ...mapState({
      leave: (state) => state.vocabularyPractice.leave,
      selectedBlockSize: (state) => state.vocabularyPractice.selectedBlockSize,
      currentRule: (state) => state.vocabularyPractice.currentRule,
      currentWord: (state) => state.vocabularyPractice.currentWord,
      currentWordIndex: (state) => state.vocabularyPractice.currentWordIndex,
      correctCount: (state) => state.vocabularyPractice.correctCount,
      incorrectCount: (state) => state.vocabularyPractice.incorrectCount,
      isRestTime: (state) => state.studyOrBreak.isRestTime,
      practiceTimes: state => state.vocabularyPractice.practiceTimes,
      practiceWordListLength: state => state.vocabularyPractice.practiceWordListLength,
      practiceMode: state => state.vocabularyPractice.practiceMode
    }),
    ...mapGetters({
      knownListLength: 'vocabularyPractice/knownListLength',
      unknownListLength: 'vocabularyPractice/unknownListLength'
    }),
    totalCount () {
      // 一般学习的总次数
      return this.correctCount + this.incorrectCount
    },
    correctRate () {
      // 一般学习的正确率
      if (this.totalCount > 0) {
        return roundDecimal((this.correctCount / this.totalCount) * 100, 2)
      }
      return 0
    }
  },
  methods: {
    // recordReady () {
    //   console.info('按钮就绪!')
    // },
    // recordStart (idx) {
    //   console.info('录音开始')
    //   this.speechInput = true
    // },
    // showResult (text) {
    //   console.info('收到识别结果：', text)
    // },
    // recordStop () {
    //   console.info('录音结束')
    // },
    // recordNoResult () {
    //   console.info('没有录到什么，请重试')
    // },
    // recordComplete (text) {
    //   console.info('识别完成! 最终结果：', text)
    //   text = text.replace('.', '').trim().toLowerCase()
    //   for (let i = 0; i < text.length; i++) {
    //     const currentWord = this.currentWord.word
    //     if (
    //       currentWord[i] === undefined ||
    //       !currentWord[i] ||
    //       text[i] !== currentWord[i]
    //     ) {
    //       this.speechInputString.push({
    //         style: { color: '#ed1c24' },
    //         character: text[i]
    //       })
    //       this.hasError = true
    //     } else if (text[i] === currentWord[i]) {
    //       this.speechInputString.push({
    //         style: { color: '#ffffff' },
    //         character: text[i]
    //       })
    //     }
    //   }
    //   if (!this.hasError) {
    //     this.correctStringStyle = {
    //       color: '#51ea8b'
    //     }
    //   }
    //   this.completeOneWordInput(600)
    // },
    // recordFailed (error) {
    //   console.info('识别失败，错误栈：', error)
    // },
    onKeydown (event) {
      if (event.repeat || this.isRestTime) {
        return
      }
      if (!this.isStarted && event.key === ' ') {
        this.closeAndContinueHandler()
      } else if (!this.isStarted && this.leave && event.key === 'b') {
        this.leaveHandler()
      } else if (this.isStarted && this.practiceMode === PRACTICEMODE.SKIPTYPING && event.key === 'ArrowRight') {
        this.moveToNextWord_SKIPTYPING()
      } else if (this.isStarted && this.practiceMode === PRACTICEMODE.SKIPTYPING && event.key === 'ArrowLeft') {
        this.backToPreviousWord_SKIPTYPING()
      } else if (!event.ctrlKey && event.key.length === 1) {
        if (!this.isStarted) {
          this.isStarted = true
          this.timer.startTimer()
        }
        if (this.practiceMode === PRACTICEMODE.NORMAL) {
          this.inputText(event)
        }
      }
    },
    inputText (event) {
      if (this.currentWord.word[this.correctString.length] === event.key) {
        this.correctString += event.key
        this.errorCharacter = ''
        if (this.correctString === this.currentWord.word) {
          this.correctStringStyle = {
            color: '#51ea8b'
          }
          this.completeOneWordInput(300)
        }
      } else {
        this.playWrongSound()
        this.errorCharacter = event.key
        this.hasError = true
      }
    },
    completeOneWordInput (ms) {
      this.timeoutManager.setTimeout(() => {
        this.countPerWord += 1
        if (!this.hasError) {
          this.$store.commit('vocabularyPractice/setCorrect')
        } else {
          this.$store.commit('vocabularyPractice/setIncorrect')
        }

        const encourageText = this.encourageTexts[this.encourageTextIndex]
        const remainingTimes = this.practiceTimes - this.countPerWord
        this.$bvToast.hide('inPracticeToast')
        if (remainingTimes <= 5 && remainingTimes > 0) {
          let encourageMsg = ''
          if (remainingTimes >= 2) {
            encourageMsg = 'giveAnEncourageMessage1'
          } else {
            encourageMsg = 'giveAnEncourageMessage2'
          }
          this.msgInPractice = `${
            this.$t(`Vocabulary.${encourageMsg}`,
              [remainingTimes, encourageText]
            )}`
          this.$bvToast.show('inPracticeToast')
          this.encourageTextIndex = (this.encourageTextIndex + 1) % 6
        }
        this.moveToNext()
      }, ms)
    },
    moveToNextWord_SKIPTYPING () {
      if (this.currentWordIndex < this.unknownListLength - 1) {
        this.$store.commit('vocabularyPractice/setNextCurrentWord')
        this.playWordDefault()
      } else if (this.currentWordIndex === this.unknownListLength - 1) {
        this.uploadResult()
      }
    },
    backToPreviousWord_SKIPTYPING () {
      if (this.currentWordIndex > 0) {
        this.$store.commit('vocabularyPractice/setPreviousCurrentWord')
        this.playWordDefault()
      }
    },
    moveToNext () {
      /**
       * 若該字已正確 threshold_frequency_learning 次，則換下一個字。
       * 若到達練習結束則顯示成績modal
       */
      if (
        this.countPerWord >
        this.practiceTimes - 1
      ) {
        if (this.currentWordIndex < this.unknownListLength - 1) {
          this.$store.commit('vocabularyPractice/setNextCurrentWord')
          this.encourageTextIndex = 0
          this.countPerWord = 0
        } else if (this.currentWordIndex === this.unknownListLength - 1) {
          this.uploadResult()
          return
        }
      }
      this.playWordDefault()
      // this.speechInput = false
      // this.speechInputString = [
      //   {
      //     style: null,
      //     character: ''
      //   }
      // ]
      this.correctString = ''
      this.errorCharacter = ''
      this.correctStringStyle = {}
      this.hasError = false
    },
    uploadResult () {
      this.isStarted = false
      this.timer.stopTimer()

      this.$store.dispatch('vocabularyPractice/uploadPracticeResult', {
        timeElapsed: this.timer.timeElapsed
      })

      /** Modal */
      const currentRecordProperties = [
        {
          label: this.$t('Vocabulary.numberOfQuestions'),
          value: `${this.practiceWordListLength}`
        },
        {
          label: this.$t('Vocabulary.practiceCount'),
          value: this.practiceMode === PRACTICEMODE.NORMAL ? `${this.totalCount}` : `（无）`
        },
        {
          label: this.$t('Vocabulary.incorrectCount'),
          value: this.practiceMode === PRACTICEMODE.NORMAL ? `${this.incorrectCount}` : `（无）`
        },
        {
          label: this.$t('Vocabulary.correctCount'),
          value: this.practiceMode === PRACTICEMODE.NORMAL ? `${this.correctCount}` : `（无）`
        },
        {
          label: this.$t('Vocabulary.usedTime'),
          value: `${secondToHMS(this.timer.timeElapsed / 1000)}`
        }
      ]
      this.currentRecordDisplayScore = `${this.$t('Vocabulary.correctRate')} ${
        this.correctRate
      }%`
      this.currentRecordHeaderText = this.$t(
        'Vocabulary.practiceResultAsBelow'
      )
      this.$refs.practiceWordResultModal.showModal(currentRecordProperties)
      if (this.correctRate === 100) {
        this.playAudio(require('@/assets/Vocabulary/sounds/super.mp3'))
      } else if (this.correctRate >= 80 && this.correctRate < 100) {
        this.playAudio(require('@/assets/Vocabulary/sounds/cool.mp3'))
      } else if (this.correctRate < 80) {
        this.playAudio(require('@/assets/Vocabulary/sounds/good.mp3'))
      }
    },
    leaveHandler () {
      this.$store.commit('vocabularyPractice/resetPractice')
      this.$refs.practiceWordResultModal.closeModal()
      this.$router.replace('/vocabulary')
    },
    closeAndContinueHandler () {
      this.$store.commit('vocabularyPractice/resetPractice')
      this.$refs.practiceWordResultModal.closeModal()
      this.showTestView()
    },
    playAudio (src) {
      if (!src) {
        return
      }

      const audio = new SafeAudio(src)
      audio.play()
      delete audio.audio
    },
    playWordDefault () {
      if (!this.currentWord) {
        return
      }

      if (this.currentWord.us_pron && this.currentWord.us_pron.length > 0) {
        this.playAudio(this.currentWord.us_pron)
      } else if (
        this.currentWord.uk_pron &&
        this.currentWord.uk_pron.length > 0
      ) {
        this.playAudio(this.currentWord.uk_pron)
      }
    },
    playWrongSound () {
      this.playAudio(
        require('@/assets/Vocabulary/sounds/glossary-test-answer-wrong.mp3')
      )
    }
  }
}
</script>

<style lang='scss' scoped>
@import "./styles/PracticeViewContent.scss";
</style>
